/**
 *
 * @module userActivityAction
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef UserActivityAction
 * @type {Object}
 * @since 3.4.0
 *
 * @property {String} CLICK
 *
 */

/**
 *
 * @enum
 * @type {UserActivityAction}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    CLICK: null
});



// WEBPACK FOOTER //
// ./src/userActivity/personalization/userActivityAction.js